

export default {
    SET_TOTAL_KODE_AKUN(state, payload){
        state.totalKodeAkun = payload
    },
    SET_TOTAL_MASTER(state, payload){
        state.totalMaster = payload
    },
    SET_TOTAL_SETTING(state, payload){
        state.totalSetting = payload
    },
    SET_TOTAL_PEMBAGIAN(state, payload){
        state.totalPembagian = payload
    },
    SET_MASTER_LIST(state, payload){
        state.masterList = payload
    },
    SET_PEMBAGIAN_LIST(state, payload){
        state.pembagianList = payload
    },
    SET_KODE_AKUN_LIST(state, payload){
        state.kodeAkunList = payload
    }
}
